@if (canShowItem(model.buergschaftsArt)) {
    <div class="angaben__group">
        <div class="angaben__label">Bürgschaftsart</div>
        <div class="angaben__value">{{ translate(model.buergschaftsArt.value) }}</div>
    </div>
}

<!-- Sichtbar, wenn Ausführungsbürgschaft -->
@if (canShowItem(model.ausfuehrungsbuergschaftenDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Voraussichtliches Datum der Fertigstellung der Bauleistungen</div>
        <div class="angaben__value">{{ model.ausfuehrungsbuergschaftenDatum.value }}</div>
    </div>
}

<!-- Sichtbar, wenn Vertragserfüllungsbürgschaft -->
@if (canShowItem(model.vertragserfuellungsbuergschaftenDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Voraussichtliches Datum der Abnahme der Bauleistungen</div>
        <div class="angaben__value">{{ model.vertragserfuellungsbuergschaftenDatum.value }}</div>
    </div>
}

<!-- Sichtbar, wenn Gewährleistungsbürgschaft -->
@if (canShowItem(model.gewaehrleistungsbuergschaftenDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Datum der Abnahme der Bauleistungen</div>
        <div class="angaben__value">{{ model.gewaehrleistungsbuergschaftenDatum.value }}</div>
    </div>
}

<!-- Sichtbar, wenn Gewährleistungsbürgschaft -->
@if (canShowItem(model.schlussrechnungsDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Schlussrechnungs-Datum</div>
        <div class="angaben__value">{{ model.schlussrechnungsDatum.value }}</div>
    </div>
}

<!-- Sichtbar, wenn Bietungsbürgschaft -->
@if (canShowItem(model.bietungsbuergschaftenDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Datum des Ablaufs der Zuschlagfrist</div>
        <div class="angaben__value">{{ model.bietungsbuergschaftenDatum.value }}</div>
    </div>
}

<!-- Sichtbar, wenn Bauhandwerkersicherungsbürgschaft (gem § 650f BGB) -->
@if (canShowItem(model.bauhandwerkersicherungssbuergschaftenDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Voraussichtliches Datum der Abnahme der Bauleistungen</div>
        <div class="angaben__value">{{ model.bauhandwerkersicherungssbuergschaftenDatum.value }}</div>
    </div>
}

<!-- Sichtbar, wenn Vorauszahlungsbürgschaft -->
@if (canShowItem(model.vorauszahlungsbuergschaftenDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Voraussichtliches Datum der Fertigstellung der Bauleistungen</div>
        <div class="angaben__value">{{ model.vorauszahlungsbuergschaftenDatum.value }}</div>
    </div>
}

<div class="angaben__group">
    <div class="angaben__label">Bürgschaftssumme</div>
    <div class="angaben__value">{{ model.buergschaftshoehe.value | correctAndFormatMoney }}</div>
</div>

<div class="angaben__group">
    <div class="angaben__label">entspricht</div>
    <div class="angaben__value">{{ model.prozentSatz.value }} % der Bausumme</div>
</div>

@if (canShowItem(model.vertragsDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Vertrag/Auftrag vom</div>
        <div class="angaben__value">{{ model.vertragsDatum.value }}</div>
    </div>
}

@if (canShowItem(model.vertragsnummer)) {
    <div class="angaben__group">
        <div class="angaben__label">Vertrags-/Auftragsnummer</div>
        <div class="angaben__value">{{ model.vertragsnummer.value }}</div>
    </div>
}

<!-- Bürgschaftstemplate -->

@if (canShowItem(model.gewuenschtesFormular)) {
    <div class="angaben__group">
        <div class="angaben__label">Gewünschtes Formular</div>
        <div class="angaben__value">{{ getFormularText() }}</div>
    </div>
}

@if (model.templateSpBeschreibung && !model.moechteAbweichendenBuergschaftstext) {
    <div class="angaben__group">
        <div class="angaben__label">Formularbeschreibung des Auftraggebers</div>
        <div class="angaben__value">{{ model.templateSpBeschreibung }}</div>
    </div>
}

@if (canShowBuergschaftszusaetze()) {
    <div class="angaben__group">
        <div class="angaben__label">Gewünschte Bürgschaftszusätze</div>
        @if (model.checkboxHinterlegung.value) {
            <div class="angaben__value">Hinterlegung</div>
        }
        @if (model.checkboxBGB768.value) {
            <div class="angaben__value">§ 768 BGB</div>
        }
        @if (model.checkboxSGBVII150Abs3.value) {
            <div class="angaben__value">§ 150 Abs. 3 SGB VII</div>
        }
        @if (model.checkboxSGBIV28eAbs3a.value) {
            <div class="angaben__value">§ 28 e Abs 3a SGB IV</div>
        }
        @if (model.checkboxSicherheitseinbehalt.value) {
            <div class="angaben__value">Sicherheitseinbehalt</div>
        }
        @if (model.checkboxAentG14.value) {
            <div class="angaben__value">§ 14 AentG</div>
        }
    </div>
}

@if (getFileName(0) || getFileName(1) || getFileName(2)) {
    <div class="angaben__group">
        <div class="angaben__label">Hochgeladene Datei(en)</div>
        @if (getFileName(0)) {
            <div class="angaben__value">{{ getFileName(0) }}</div>
        }
        @if (getFileName(1)) {
            <div class="angaben__value">{{ getFileName(1) }}</div>
        }
        @if (getFileName(2)) {
            <div class="angaben__value">{{ getFileName(2) }}</div>
        }
    </div>
}

<!-- Bürgschaftstemplate Ende -->

@if (canShowItem(model.frist)) {
    <div class="angaben__group">
        <div class="angaben__label">Die Bürgschaft ist</div>
        <div class="angaben__value">{{ translate(model.frist.value) }}</div>
    </div>
}

@if (canShowItem(model.frist) && model.frist.value === 'befristet' && canShowItem(model.fristDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Befristungsdatum</div>
        <div class="angaben__value">{{ model.fristDatum.value }}</div>
    </div>
}

@if (canShowItem(model.gesetzlGrundlage)) {
    <div class="angaben__group">
        <div class="angaben__label">Der Bauvertrag wurde vereinbart nach</div>
        <div class="angaben__value">{{ model.gesetzlGrundlage.value }}</div>
    </div>
}

@if (canShowItem(model.gewaehrleistungsfrist)) {
    <div class="angaben__group">
        <div class="angaben__label">Gewährleistungsfrist</div>
        <div class="angaben__value">{{ getGewaehrleistungsfrist() }}</div>
    </div>
}

@if (model.checkboxHatBesondereHinweise.value && canShowItem(model.besondereHinweise)) {
    <div class="angaben__group">
        <div class="angaben__label">Besondere Hinweise zur Bürgschaft</div>
        <div class="angaben__value">{{ model.besondereHinweise.value }}</div>
    </div>
}

@if (canShowItem(model.auftragsortGewerk)) {
    <div class="angaben__group">
        <div class="angaben__label">Gewerk / Art der Arbeit</div>
        <div class="angaben__value">{{ model.auftragsortGewerk.value }}</div>
    </div>
}

@if (model.auftragsortVerfuegbar.value === 'AV') {
    <div class="angaben__group">
        <div class="angaben__label">Ort der Arbeit</div>
        @if (canShowItem(model.auftragsortStrasseNr)) {
            <div class="angaben__value">
                {{ model.auftragsortStrasseNr.value }}
            </div>
        }
        <div class="angaben__value">
            @if (canShowItem(model.auftragsortPlz)) {
                {{ model.auftragsortPlz.value }}
            }&nbsp;@if (canShowItem(model.auftragsortOrt)) {
            {{ model.auftragsortOrt.value }}
        }
        </div>
    </div>
}

@if (model.auftragsortVerfuegbar.value === 'KA') {
    <div class="angaben__group">
        <div class="angaben__label">Ort der Arbeit</div>
        @if (canShowItem(model.auftragsortBeschreibung)) {
            <div class="angaben__value">
                {{ model.auftragsortBeschreibung.value }}
            </div>
        }
    </div>
}

<div class="angaben__group">
    @if (model.versandartAuswahlAvailable) {
        <div class="angaben__label">Bürgschaftsformat</div>
        @if (canShowItem(model.buergschaftsformat)) {
            <div class="angaben__value">
                {{ model.buergschaftsformat.value == 'PDF' ? 'PDF-Bürgschaft' : 'Papierbürgschaft' }}
            </div>
        }
    } @else {
        <div class="angaben__label">Bürgschaftsformat</div>
        <div class="angaben__value">{{ this.model.templateSpKennung.value && !this.model.moechteAbweichendenBuergschaftstext ? 'Digitale Bürgschaft' : 'Papierbürgschaft' }}</div>
        @if (this.model.templateSpKennung.value && this.model.moechteAbweichendenBuergschaftstext) {
            <div class="angaben__value">(aufgrund der Auswahl eines abweichenden Bürgschaftstexts)</div>
        }
    }
</div>



@if (!printMode) {
    <div class="angaben__button">
        <elem-button icon="icon-edit_1"
                     buttonRole="SMALL"
                     (click)="context.setCreationState(context.STATE_3_BUERGSCHAFT, false)">
            Ändern
        </elem-button>
    </div>
}
